/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { hover } from 'app/utils/cssUtils';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  checked?: boolean,
  disabled?: boolean,
  children: React.Node,
  className?: string,
  onChange: boolean => void,
  scheme?: 'light' | 'dark',
};

const defaultProps = {
  checked: false,
  disabled: false,
  className: '',
  scheme: 'light',
};

const StyledButton = glamorous.span(
  ({ theme, scheme }) => ({
    alignItems: 'center',
    borderColor: theme.color.basis4,
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 2,
    color: scheme === 'light' ? theme.color.basis3 : theme.color.basis5,
    display: 'flex',
    justifyContent: 'center',
    outline: 0,
    padding: '0.375em 0.125em',
    textAlign: 'center',
    textTransform: 'uppercase',
    width: '100%',
    transition: 'all 0.2s',
    ...hover({
      borderColor: theme.color.basis5,
      color: theme.color.basis5,
    }),
  }),
  ({ theme, checked, scheme }) => (
    checked && {
      backgroundColor: scheme === 'light' ? theme.color.basis2 : theme.color.basis6,
      borderColor: scheme === 'light' ? theme.color.basis2 : theme.color.basis6,
      color: scheme === 'light' ? theme.color.basis6 : theme.color.basis2,
    }
  ),
  ({ disabled }) => (
    disabled && {
      opacity: 0.5,
    }
  ),
);

function CheckButton({ checked, disabled, onChange, children, className, scheme }: Props) {
  return (
    <Tappable
      className={className}
      component={StyledButton}
      checked={checked}
      disabled={disabled}
      scheme={scheme}
      type="button"
      onTap={() => onChange(!checked)}
    >
      {children}
    </Tappable>
  );
}

CheckButton.defaultProps = defaultProps;

export default CheckButton;
